import { useEffect, useState } from 'react';

import cx from 'classnames';

import { useWebSockets } from '@motorway/motorway-handshake-components';

import styles from './Connection.module.scss';

export const Connection = () => {
  const [displayText, setDisplayText] = useState(true);
  const { status } = useWebSockets();

  const isConnected = status?.connected;

  useEffect(() => {
    const showTimer = setTimeout(() => { setDisplayText(true); }, 0);
    const hideTimer = setTimeout(() => { setDisplayText(false); }, 2000);

    return () => {
      clearTimeout(showTimer);
      clearTimeout(hideTimer);
    };
  }, [isConnected]);

  useEffect(() => {
    console.log('Connection status changed:', status);
  }, [status]);

  return (
    <div className={cx(
      styles.component,
      {
        [styles.connected]: isConnected,
        [styles.displayText]: displayText,
      },
    )}
    >
      <div className={styles.status}>
        {!displayText && (<span></span>)}
      </div>
      {
        displayText && (
          <span className={styles.text}>
            {isConnected ? 'Connected!' : 'Connecting...'}
          </span>
        )
      }
    </div>
  );
};
